module.exports = __webpack_public_path__ + "img/girl_right.746875a5.svg";